import { ICustomProductOptionConfigItem } from "@evennt-tech/api-v2-core";
import { FullProduct } from "ts/api/product";
import {
  LocalizedNameTranslate,
  resolveLocalizedName,
} from "tools/localization/resolveLocalizedName";
import { isColorItem } from "tools/custom-product-option/common";

export const resolveLocalizedConfig = <
  T extends { items?: ICustomProductOptionConfigItem[] }
>(
  config: T,
  t: LocalizedNameTranslate
): T => ({
  ...config,
  items: config.items?.map((item) =>
    item.cpoItem && isColorItem(item)
      ? { ...item, cpoItem: resolveLocalizedName(item.cpoItem, t) }
      : item
  ),
});

const resolveLocalizedProduct = (
  product: FullProduct,
  t: LocalizedNameTranslate
): FullProduct => ({
  ...product,
  categories: product.categories.map((category) => ({
    ...category,
    ...(category.mainCategory && {
      mainCategory: resolveLocalizedName(category.mainCategory, t),
    }),
    ...(category.subCategory && {
      subCategory: resolveLocalizedName(category.subCategory, t),
    }),
  })),
  configs: product.configs.map((config) => resolveLocalizedConfig(config, t)),
});

export default resolveLocalizedProduct;
